import * as React from "react";
import * as _ from "lodash";
import { Dispatch, connect } from "react-redux";
import { IReportState, IApplicationState, AppActionCreators, ReportActionCreators, ILateDonorReviewsResponse } from "@nkr/store/index";
import LateDonorReviewsReportGrid from "./late-donor-reviews-grid";

import 'ag-grid-community/dist/styles/ag-theme-bootstrap.css';

interface IOwnProps {centerId: number }

interface IStateProps {
    reports: IReportState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getLateDonorReviews: (centerId: number, year: number, month: number) => Promise<ILateDonorReviewsResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps

interface IState {
}

class LateDonorReviewsReport extends React.Component<TProps, IState> {
    render = () => {
        return (
            <>
                <LateDonorReviewsReportGrid
                    getLateDonorReviews={this.props.getLateDonorReviews}
                    centerId={this.props.centerId}
                    showLoading={this.props.showLoading}
                    hideLoading={this.props.hideLoading}
                />
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        reports: appState.reports
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getLateDonorReviews: (centerId, year, month) => {
            return dispatch(ReportActionCreators.getLateDonorReviews(centerId, year, month));
        }
    }
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(LateDonorReviewsReport);